var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.7954,
    y: 1,
    width: 39.4272,
    height: 47.3181,
    rx: 2,
    fill: "white",
    stroke: "#7CAFED",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 8.08838,
    width: 24.8563,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 14.0063,
    width: 24.8563,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 19.9246,
    width: 24.8563,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 25.8428,
    width: 24.8563,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 31.7607,
    width: 24.8563,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0808,
    y: 37.679,
    width: 15.3872,
    height: 1.77545,
    rx: 0.887726,
    fill: "#A0BCDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.3286,
    cy: 28.7033,
    r: 11.9213,
    stroke: "#2E77D0",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6233,
    y: 37.9668,
    width: 3.94545,
    height: 13.02,
    rx: 1.97272,
    transform: "rotate(-48.611 47.6233 37.9668)",
    fill: "#2E77D0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 32.55,
    width: 28.4072,
    height: 25.0536,
    rx: 4,
    fill: "#FADA86"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 9.27197,
    y: 32.55,
    width: 9.66635,
    height: 25.0536,
    fill: "#EBAA05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditDash);
export default __webpack_public_path__ + "static/media/audit-dash.d954e503c5f253c801fb8274271def59.svg";
export { ForwardRef as ReactComponent };